export const countryCode = (country: string) => {
  switch (country) {
    case 'es':
      return 'es'
    default:
      return 'global'
  }
}
